import React from "react";
import * as Animatable from 'react-native-animatable';
import { Pressable, View, ViewStyle } from "react-native";
import { MaterialIcons } from '@expo/vector-icons';
import { themeSelector } from "@reduxLocal/selectors/themeSelector";
import { ViewProps } from "react-native";


const CloseButton = ({ handleClose, style, position = 'absolute', right = 12, top = 12 }: { handleClose: () => void; style?: ViewProps; position?: 'absolute' | 'relative'; right?: number; top?: number }) => {
  const theme = themeSelector();
return (
        <Animatable.View
          animation="bounceIn"
          delay={200}
    style={[{
            position: 'absolute',
            right: right || 12,
            top: top || "7%",
            backgroundColor: theme
              ? 'rgba(239, 68, 68, 0.9)'
              : 'rgba(239, 68, 68, 0.8)',
            borderRadius: 20,
            width: 36,
            height: 36,
            zIndex: 1000,
            shadowColor: '#ef4444',
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: 0.4,
            shadowRadius: 8,
            elevation: 6,
            backdropFilter: 'blur(10px)',
            borderWidth: 1,
            borderColor: theme
              ? 'rgba(255, 255, 255, 0.3)'
              : 'rgba(255, 255, 255, 0.1)',
    },
      style]}
        >
          <Pressable
            style={{
              flex: 1,
              justifyContent: 'center',
              alignItems: 'center'
            }}
            onPress={handleClose}
          >
            <MaterialIcons name="close" size={20} color="white" />
          </Pressable>
        </Animatable.View>
)
}
export default CloseButton;